import { accountSlice } from './account.reducer';

export const {
  SET_ACCOUNT,
  SET_DB_SETTING,
  SET_INC_SETTINGS,
  SET_GROUP,
  RESET_ACCOUNT,
  UPDATE_DASHBOARD_SETTINGS,
} = accountSlice.actions;
